import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetWorklistsItemCount = () => axios.get(`${apiPaths.worklistBase}/item-counts`);

export { onGetWorklistsItemCount };
